"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto px-4" };
const _hoisted_2 = {
    key: 0,
    class: "uppercase md:text-xl lg:text-2xl xl:text-3xl font-bold text-white mb-6"
};
const _hoisted_3 = { class: "flash-search-links-grid" };
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
    class: "marso-icon-chevron-right",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
    class: "marso-icon-chevron-right",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
    class: "marso-icon-chevron-right",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
    class: "marso-icon-chevron-right",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
    class: "marso-icon-chevron-right",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
    class: "marso-icon-chevron-right",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
    class: "marso-icon-chevron-right",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
    class: "marso-icon-chevron-right",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_12 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
    class: "marso-icon-chevron-right",
    "aria-hidden": "true"
}, null, -1);
const _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", {
    class: "marso-icon-chevron-right",
    "aria-hidden": "true"
}, null, -1);
const vue_3 = require("vue");
const i18n_1 = require("../../common/i18n");
const securityStore_1 = require("../../stores/security/securityStore");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ShopMenu',
    setup(__props) {
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const isQuickSearchVisible = (0, vue_3.computed)(() => {
            var _a, _b;
            const userPermissions = (_b = (_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.permissions) !== null && _b !== void 0 ? _b : [];
            const searchPagePermissions = [
                PermissionEnum_1.UserPermissionEnum.SHOW_PASSENGER_TYRES,
                PermissionEnum_1.UserPermissionEnum.SHOW_TRUCK_TYRES,
                PermissionEnum_1.UserPermissionEnum.SHOW_AGRICULTURAL_AND_INDUSTRIAL_TYRES,
                PermissionEnum_1.UserPermissionEnum.SHOW_FORKLIFT_TYRES,
                PermissionEnum_1.UserPermissionEnum.SHOW_MOTORCYCLES_TYRES,
                PermissionEnum_1.UserPermissionEnum.SHOW_RIMS_AND_TPMSS_BY_CAR_TYPE,
                PermissionEnum_1.UserPermissionEnum.SHOW_RIMS_BY_SIZE,
                PermissionEnum_1.UserPermissionEnum.SHOW_TUBES_AND_TAPES,
                PermissionEnum_1.UserPermissionEnum.SHOW_ACCESSORIES,
                PermissionEnum_1.UserPermissionEnum.SHOW_SEARCH_BY_SKU
            ];
            return searchPagePermissions.some(permission => userPermissions.includes(permission));
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            const _component_router_link = (0, vue_2.resolveComponent)("router-link");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: "bg-gray-darker py-4 bg-cover bg-bottom bg-no-repeat bg-image",
                style: (0, vue_2.normalizeStyle)(`background-image: url('${require('../../images/dashboard_shop_menu_background.png')}');`)
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    ((0, vue_2.unref)(isQuickSearchVisible))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("h3", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("quick_searcher", `Quick search`, "dashboard")), 1))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        ((_a = (0, vue_2.unref)(currentUser)) === null || _a === void 0 ? void 0 : _a.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).SHOW_PASSENGER_TYRES))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                key: 0,
                                to: { name: 'shop_passenger_tyres' },
                                class: "flash-link"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("passenger_tyres", "Passenger tyres", "dashboard")), 1),
                                    _hoisted_4
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((_b = (0, vue_2.unref)(currentUser)) === null || _b === void 0 ? void 0 : _b.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).SHOW_TRUCK_TYRES))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                key: 1,
                                to: { name: 'shop_truck_tyres' },
                                class: "flash-link"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("truck_tyres", "Truck tyres", "dashboard")), 1),
                                    _hoisted_5
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((_c = (0, vue_2.unref)(currentUser)) === null || _c === void 0 ? void 0 : _c.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).SHOW_AGRICULTURAL_AND_INDUSTRIAL_TYRES))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                key: 2,
                                to: { name: 'shop_agricultural_and_industrial_tyres' },
                                class: "flash-link"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("agricultural_and_industrial_tyres", "Agricultural and Industrial tyres", "dashboard")), 1),
                                    _hoisted_6
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((_d = (0, vue_2.unref)(currentUser)) === null || _d === void 0 ? void 0 : _d.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).SHOW_FORKLIFT_TYRES))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                key: 3,
                                to: { name: 'shop_forklift_tyres' },
                                class: "flash-link"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("forklift_tyres", "Forklift tyres", "dashboard")), 1),
                                    _hoisted_7
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((_e = (0, vue_2.unref)(currentUser)) === null || _e === void 0 ? void 0 : _e.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).SHOW_MOTORCYCLES_TYRES))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                key: 4,
                                to: { name: 'shop_motorcycle_tyres' },
                                class: "flash-link"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("motorcycle_tyres", "Motorcycle tyres", "dashboard")), 1),
                                    _hoisted_8
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((_f = (0, vue_2.unref)(currentUser)) === null || _f === void 0 ? void 0 : _f.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).SHOW_RIMS_AND_TPMSS_BY_CAR_TYPE))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                key: 5,
                                to: { name: 'shop_rim_search_by_car' },
                                class: "flash-link"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("rims_and_tpmss_by_car", "Rims and TPMSs by car", "dashboard")), 1),
                                    _hoisted_9
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((_g = (0, vue_2.unref)(currentUser)) === null || _g === void 0 ? void 0 : _g.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).SHOW_RIMS_BY_SIZE))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                key: 6,
                                to: { name: 'shop_rim_search' },
                                class: "flash-link"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("rim_by_size", "Rims by size", "dashboard")), 1),
                                    _hoisted_10
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((_h = (0, vue_2.unref)(currentUser)) === null || _h === void 0 ? void 0 : _h.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).SHOW_TUBES_AND_TAPES))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                key: 7,
                                to: { name: 'shop_tube_and_tape_product_search' },
                                class: "flash-link"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("tubes_and_tapes", "Tubes and tapes", "dashboard")), 1),
                                    _hoisted_11
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        (!((_j = (0, vue_2.unref)(currentUser)) === null || _j === void 0 ? void 0 : _j.hasPermission((0, vue_2.unref)(PermissionEnum_1.CustomerPermissionEnum).EXPORT_PARTNER)) && ((_k = (0, vue_2.unref)(currentUser)) === null || _k === void 0 ? void 0 : _k.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).SHOW_ACCESSORIES)))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                key: 8,
                                to: { name: 'shop_accessories_search' },
                                class: "flash-link"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("accessories", "Accessories", "dashboard")), 1),
                                    _hoisted_12
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        ((_l = (0, vue_2.unref)(currentUser)) === null || _l === void 0 ? void 0 : _l.hasPermission((0, vue_2.unref)(PermissionEnum_1.UserPermissionEnum).SHOW_SEARCH_BY_SKU))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                                key: 9,
                                to: { name: 'shop_sku_search' },
                                class: "flash-link"
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("sku_search", "Search by sku", "dashboard")), 1),
                                    _hoisted_13
                                ]),
                                _: 1
                            }))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ])
            ], 4));
        };
    }
});
